const LEVEL_PRIORITY = {red: 2, yellow: 1};

export function getAlertLevelTone(level) {
    const normalized = typeof level === 'string' ? level.trim().toLowerCase() : '';
    return Object.prototype.hasOwnProperty.call(LEVEL_PRIORITY, normalized) ? normalized : 'default';
}

export function normalizeAlarmInfo(data) {
    // A malformed response must not be interpreted as an all-clear.
    if (!data || !Array.isArray(data.activeAlerts)
        || data.activeAlerts.some(type => typeof type !== 'string' || !type.trim())) {
        throw new Error('Invalid alarms response');
    }

    const activeAlerts = [...new Set(data.activeAlerts)];
    const activeAlertLevels = Array.isArray(data.activeAlertLevels)
        ? data.activeAlertLevels
            .filter(level => level && typeof level === 'object')
            .map(level => ({
                alertLevel: typeof level.alertLevel === 'string' ? level.alertLevel.trim() : '',
                reason: typeof level.reason === 'string' ? level.reason.trim() : '',
                createdAt: typeof level.createdAt === 'string' ? level.createdAt : null,
            }))
            .filter(level => level.alertLevel || level.reason)
            .sort((a, b) => (LEVEL_PRIORITY[getAlertLevelTone(b.alertLevel)] || 0)
                - (LEVEL_PRIORITY[getAlertLevelTone(a.alertLevel)] || 0)
                || JSON.stringify(a).localeCompare(JSON.stringify(b)))
        : [];

    return {
        activeAlerts,
        // Alert types determine whether the alarm is active, including legacy responses.
        activeAlertLevels: activeAlerts.length ? activeAlertLevels : [],
    };
}
